import * as React from 'react';
import styled from 'styled-components';

const GuaranteeContainer = styled.div`
  background: #f8f9fa;
  border: 2px solid #4caf50;
  border-radius: 12px;
  padding: 25px;
  margin: 20px 0;
  text-align: center;
`;

const GuaranteeIcon = styled.div`
  margin-bottom: 15px;
  
  i {
    font-size: 64px;
    color: #4caf50;
  }
`;

const GuaranteeTitle = styled.h3`
  color: #4caf50;
  margin: 0 0 10px 0;
  font-size: 24px;
  font-weight: bold;
`;

const GuaranteeText = styled.p`
  color: #666;
  font-size: 16px;
  line-height: 1.6;
  margin: 0;
  max-width: 600px;
  margin: 0 auto;
`;

const BenefitsList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-top: 20px;
`;

const Benefit = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;

  i {
    color: #4caf50;
    font-size: 24px;
  }

  span {
    font-size: 14px;
    color: #333;
  }
`;

export const GuaranteeSection: React.FC = () => {
  return (
    <GuaranteeContainer>
      <GuaranteeIcon>
        <i className="material-icons">verified</i>
      </GuaranteeIcon>
      <GuaranteeTitle>Garantia de 7 Dias</GuaranteeTitle>
      <GuaranteeText>
        Experimente sem riscos! Se não ficar satisfeito com nosso serviço, 
        devolvemos 100% do seu dinheiro nos primeiros 7 dias. Sem perguntas, 
        sem complicações.
      </GuaranteeText>
      
      <BenefitsList>
        <Benefit>
          <i className="material-icons">check_circle</i>
          <span>Cancelamento fácil</span>
        </Benefit>
        <Benefit>
          <i className="material-icons">check_circle</i>
          <span>Reembolso total</span>
        </Benefit>
        <Benefit>
          <i className="material-icons">check_circle</i>
          <span>Sem taxas ocultas</span>
        </Benefit>
        <Benefit>
          <i className="material-icons">check_circle</i>
          <span>Suporte dedicado</span>
        </Benefit>
      </BenefitsList>
    </GuaranteeContainer>
  );
};

